import { useI18n } from '@runtime/core/i18n/i18n'
import ProfileButton from '@runtime/features/profile/ProfileButton'
import PlayLanguageSelect from './PlayLanguageSelect'
import styles from './PlayRailUtilities.module.scss'

export default function PlayRailUtilities({ onAction }: { onAction: () => void }) {
  const { t } = useI18n()
  return (
    <section
      className={styles.utilities}
      aria-label={t('common.playNavigation.actionsLabel')}
      data-testid="play-rail-utilities"
    >
      <PlayLanguageSelect />
      <div
        onClick={event => {
          if (event.target instanceof Element && event.target.closest('button')) onAction()
        }}
      >
        <ProfileButton className={styles.profile} />
      </div>
    </section>
  )
}
